import React, { useState } from "react";
import { CategoryProduct } from "../../../domain/entities/CategoryProduct";
import iconCheck from "../../../assets/Form/ic_checkgreen.png";
import iconCircleWhite from "../../../assets/Icon/home/icon-circle-white.png";
import iconBroadband from "../../../assets/Form/ic_broadband.png";
import iconDedicatedInet from "../../../assets/Form/ic_dedicated_internet.png";
import iconPromo from "../../../assets/Form/ic_promo.png";
import { ProductItem } from "../../../domain/entities/ProductItem";

interface ButtonTabItemProps {
    category: CategoryProduct;
    isActive: boolean; // Receive active state
    onTabClick: (tabId: number, categorySlug: string, productItems: ProductItem[], category: CategoryProduct) => void; // Receive click handler
  }
  
  const ButtonTabItem: React.FC<ButtonTabItemProps> = ({ category, isActive, onTabClick }) => {
    const handleClick = () => {
      onTabClick(category.id, category.slug, category.products, category); // Notify parent of tab click
    };
  
    let componentList;
    switch (category.slug) {
      case 'broadband-internet':
        componentList = <img src={iconBroadband} alt="Icon Broadband Internet" className="w-4 h-4" />;
        break;
      case 'business-solutions':
        componentList = <img src={iconDedicatedInet} alt="Icon Business Solutions" className="w-4 h-4" />;
        break;
      default:
        componentList = <img src={iconPromo} alt="Icon Promo" className="w-4 h-4" />;
    }
  
    return (
      <button
        onClick={handleClick}
        className={`flex items-center px-4 py-2 w-full md:w-auto flex-1 rounded-full border text-sm md:text-base font-poppins
          ${isActive ? 'bg-pink-800 text-white shadow-md' : 'bg-white text-gray-900 border-gray-300'}
          hover:shadow-lg transition-all`}
        style={{ minWidth: '150px' }} // Set a minimum width for all buttons
      >
        <span>{componentList}</span>
        <span className="ml-2">{category.category}</span>
        <span className="ml-auto">
          <img
            src={isActive ? iconCheck : iconCircleWhite}
            alt="icon check"
            className="w-4 h-4"
          />
        </span>
      </button>
    );
  };
  
  export default ButtonTabItem;